import { render } from "./NotInterestedLead.vue?vue&type=template&id=4413c1b6&scoped=true"
import script from "./NotInterestedLead.vue?vue&type=script&lang=js"
export * from "./NotInterestedLead.vue?vue&type=script&lang=js"

import "./NotInterestedLead.vue?vue&type=style&index=0&id=4413c1b6&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4413c1b6"]])

export default __exports__